const translations = {
  'header': {
    'main': 'Main',
    'vozm': 'Possibilities',
    'products': 'Products',
    'docs': 'Documents',
    'request': 'Send a request',
  },
  'mainPage': {
    'title': 'Bank in one device!',
    'desc': 'Control your finances easily and conveniently!',
    'request': 'Send a request',
  },
  'vozm': {
    'mainTitle': 'Oriyon business opportunities',
    'title1': 'Simple signing of payments with SMS code',
    'title3': 'Works on any device',
  },
  'products': {
    'mainTitle': 'Products for your business',
    'title2': 'Trade acquiring',
    'title3': 'Salary project',
    'title4': 'Settlement and cash services',
  },
  'documents': {
    'mainTitle': 'Documents',
    'title1': 'Rates',
  },
  'RECEIVED': 'Received',
  'IN_PROGRESS': 'In progress',
  'IN_VERIFICATION': 'In verification',
  'IN_CONFIRMATION': 'In confirmation',
  'READY': 'Ready',
  'SUCCESS': 'Success',
  'FAILED': 'Failed',
  'DECLINED': 'Declined',
  'INVALID_FILE': 'Invalid file',
  'INVALID': 'Invalid',
  'IN_APPROVAL': 'In approval',
  'TO_APPROVE': 'To approve',
  'APPROVED': 'Approved',
  'PARTIAL_SUCCESS': 'Partial success',
  'POSTPONED': 'Postponed',
  'IN_BANK_REVIEW': 'In bank review',
  'IN_REVIEW': 'In review',
  'BANK_APPROVED': 'Bank approved',
  'CANCELED': 'Canceled',
  'BANK_DECLINED': 'Bank declined',
  'REVERSED': 'Reversed',
  'IN_VALIDATION': 'In validation',
  'READY_TO_PROCEED': 'Ready to proceed',
  'Language': 'English',
  'Transactions': 'Transactions',
  'Accounts': 'Accounts',
  'Filter': 'Filter',
  'Status': 'Status',
  'Find': 'Find',
  'ID': 'ID',
  'Name': 'Name',
  'Phone number': 'Phone number',
  'Intrabank': 'Intrabank',
  'Salaries': 'Salaries',
  'Interbank': 'Interbank',
  'Interbank payment': 'Interbank payment',
  'SWIFT': 'SWIFT',
  'Ruble': 'Ruble',
  'Account': 'Account',
  'Search': 'Search',
  'All': 'All',
  'Sign in': 'Sign in',
  'Signing in': 'Signing in',
  'Processing': 'Processing',
  'Not successful': 'Not successful',
  'Successful': 'Successful',
  'Date': 'Date',
  'Sender': 'Sender',
  'Recipient': 'Recipient',
  'Sender account': 'Sender acccount',
  'Recipient account': 'Recipient account',
  'Transaction type': 'Transaction type',
  'Amount': 'Amount',
  'Login': 'Login',
  'Password': 'Password',
  'Sign up': 'Sign up',
  'Exchange Rates': 'Exchange Rates',
  'NBT': 'NBT',
  'Currency': 'Currency',
  'Purchase': 'Buy',
  'Sale': 'Sale',
  'USD': 'USD',
  'EUR': 'EUR',
  'RUB': 'RUB',
  'All accounts': 'All accounts',
  'TJS': 'TJS',
  'Last operations': 'Last operations',
  'Between own accounts': 'Between own accounts',
  'Intrabank payment': 'Intrabank payment',
  'MyAccounts': 'My accounts',
  'Active': 'Active',
  'Not active': 'Not active',
  'Update': 'Update',
  'Updated': 'Updated',
  'Russian': 'Russian',
  'English': 'English',
  'Tajik': 'Tajik',
  'Bank accounts': 'Bank accounts',
  'Visa Business': 'Visa Business',
  'Payment Information': 'Payment Information',
  'Account Information': 'Account Information',
  'File information': 'File Information',
  'Account name': 'Account name',
  'Balance': 'Balance',
  'Account type': 'Account type',
  'Address': 'Address',
  'TIN': 'TIN',
  'Date of opening': 'Date of opening',
  'Requisites': 'Requisites',
  'Download': 'Download',
  'Upload': 'Upload',
  'Upload file': 'Upload file',
  'Description': 'Description',
  'Show filters': 'Show filters',
  'No transaction': 'No transaction',
  'TxID': 'TxID',
  'Commission': 'Commission',
  'Commission amount': 'Commission amount',
  'Commission km': 'Commissions for Korti Milli',
  'Commission visa': 'Commissions for Visa',
  'Company information': 'Информация о компании',
  'Date of creation': 'Date of creation',
  'Retry payment': 'Retry payment',
  'Download PDF': 'Download PDF',
  'Authorizers': 'Authorizers',
  'Reject': 'Reject',
  'Confirm': 'Confirm',
  'Payment information': 'Payment information',
  'Bank information': 'Bank information',
  'From account': 'From account',
  'To account': 'To account',
  'Transfer amount': 'Transfer amount',
  'Narrative': 'Narrative',
  'Existing template': 'Existing template',
  'Sender information': 'Sender information',
  'Recipient information': 'Recipient information',
  'Account number': 'Account number',
  'Confirm account number': 'Confirm account number',
  'Payment details': 'Payment details',
  'Other details': 'Other details',
  'Document type': 'Document type',
  'Document number': 'Document number',
  'Document date': 'Document date',
  'Save template': 'Save template',
  'Country': 'Country',
  'City': 'City',
  'Enter amount': 'Enter amount',
  'Document': 'Document',
  'Enter document number': 'Enter document number',
  'Initiator': 'Initiator',
  'Number of transactions': 'Number of transactions',
  'Import': 'Import',
  'Rejected': 'Rejected',
  'Importing payments from a file': 'Importing payments from a file',
  'Download document': 'Download document',
  'Salary project': 'Salary project',
  'Select account': 'Select account',
  'Select date': 'Select date',
  'Order an statement': 'Order an statement',
  'View orders': 'View orders',
  'Ordering a statement': 'Ordering a statement',
  'Enter the title': 'Enter the title',
  'Order': 'Order',
  'Ready': 'Ready',
  'Failed': 'Failed',
  'In progress': 'In progress',
  'Period': 'Period',
  'Orders': 'Orders',
  'Tariffs': 'Tariffs',
  'Transfer between own accounts': 'Transfer between own accounts',
  'Show all currencies': 'Show all currencies',
  'Rate': 'Rate',
  'Unit': 'Unit',
  'No.': 'No.',
  'Change Password': 'Change Password',
  'Log out': 'Log out',
  'Profile': 'Profile',
  'Enter a new password': 'Enter a new password',
  'Enter old password': 'Enter old password',
  'Confirm new password': 'Confirm new password',
  'Change': 'Change',
  'Contacts': 'Contacts',
  'oriyon-business@oriyonbonk.tj': 'oriyon-business@oriyonbonk.tj',
  'Call center 2222': 'Call center 2222',
  'Loans': 'Loans',
  'Deposits': 'Deposits',
  'OtpCode': 'Confirmation code',
  'ResendTime': 'Resending will be available via',
  'Second': 'second',
  'ResendCode': 'Resend code',
  'Save': 'Save',
  'All operations': 'All operations',
  'Operation': 'Operation',
  'No Transactions': 'No Transactions',
  'Payments': 'Payments',
  'More': 'More',
  'Notifications': 'Notifications',
  'No notifications': 'No notifications',
  'New': 'new',
  'CurrienciesToSomoni': 'Official exchange rate of currencies against Somoni:',
  'Hide all currencies': 'Hide all currencies',
  'ToSign': 'To sign',
  'Rejecteds': 'Rejected',
  'Enter Recipient Account': 'Enter Recipient Account',
  'Confirm payment': 'Confirm payment',
  'Payment type': 'Payment type',
  'Enter Recipient': 'Enter Recipient',
  'Enter TIN': 'Enter TIN',
  'Enter template name': 'Enter template name',
  'Recipient TIN': 'Recipient TIN',
  'Show balance': 'Show balance',
  'Hide balance': 'Hide balance',
  'Hide filters': 'Hide filters',
  'Swift': 'Swift',
  'Bank name': 'Bank name',
  'Filters': 'Filters',
  'Show': 'Show',
  'Select template': 'Select template',
  'One Dollar': '1 Dollar',
  'One Ruble': '1 Ruble',
  'One Euro': '1 Euro',
  'Orienbank Address': 'Dushanbe, Rudaki Avenue 95/1',
  'Enter City': 'Enter City',
  'Enter Country': 'Enter Country',
  'Enter Address': 'Enter Address',
  'Enter Account': 'Enter Account',
  'Enter swift code': 'Enter swift code',
  'Enter bank name': 'Enter bank name',
  'Enter doc number': 'Enter doc number',
  'Enter SMS code': 'Enter SMS code',
  'Find swift code': 'Find swift code',
  'Find bic code': 'Find bic code',
  'Required': 'Required',
  'Enter symbol only': 'Enter symbol only',
  'Amount must be more 1': 'Amount must be more 1',
  'Wrong amount': 'Wrong amount',
  'Wrong type': 'Wrong type',
  'Latin Only': 'Latin Only',
  'Account does not match': 'Account does not match!',
  'Account must contain no more than 20 digits': 'Account must contain no more than 20 digits',
  'Account must contain no more than 21 digits': 'Account must contain no more than 21 digits',
  'Account must contain no more than 35 digits': 'Account must contain no more than 35 digits',
  'Account must contain at least 6 digits': 'Account must contain at least 6 digits',
  'Account must contain at least 20 digits': 'Account must contain at least 20 digits',
  'Account must contain at least 7 digits': 'Account must contain at least 7 digits',
  'Enter number only': 'Enter number only',
  'ConfirmSmsFromPhone': 'To confirm the transaction, an SMS code has been sent to your phone number',
  'No accounts': 'No accounts',
  'Account does not found': 'Account does not found!',
  'Must be 9 numbers': 'Must be 9 numbers',
  'Field must contain at least 8 digits': 'Field must contain at least 8 digits!',
  'For registration':
    'To register in the Internet Banking system, you need to contact the central office of Orienbank, at',
  'For any questions': 'For any questions, please contact our contact center, we will be happy to help you',
  'Code': 'Code',
  'Sent code to phone for sequirity': 'To protect your profile, we will send a verification code to your phone number',
  'Sent code to email for sequirity': 'To protect your profile, we will send a verification code to your email',
  'Google auth otp description': 'You have Google Authenticator enabled. Enter the 6-digit code from the app.',
  'Change your password': 'Change your password',
  'Password does not match': 'Password does not match',
  'Confirm password': 'Confirm password',
  'Change and remind password': 'Change and remember your password',
  'International': 'International transfer',
  'International tjs': 'Swift in Somoni',
  'File date': 'File date',
  'Total amount': 'Total amount',
  'Debit': 'Debit',
  'Credit': 'Debit',
  'Own accounts payments': 'Own accounts payments',
  'Intrabank payments': 'Intrabank payments',
  'Interbank payments': 'Interbank payments',
  'Successful count': 'Successful count',
  'Not successful count': 'Not successful count',
  'Download file': 'Download file',
  'Error': 'Error',
  'Transaction list': 'Transaction list',
  'Branch': 'Branch',
  'Approved': 'Approved',
  'From amount': 'From amount',
  'To amount': 'To amount',
  'Start date': 'Start date',
  'End date': 'End date',
  'Start period': 'Start period',
  'End period': 'End Period',
  'No data': 'No data',
  'Enter document type': 'Enter document type',
  'In confirmation': 'In confirmation',
  'In verification': 'In verification',
  'Partial success': 'Partial success',
  'Download salary file template': 'Download salary file template',
  'Upload document': 'Upload document',
  'The file format must be xlsx, xls': 'The file format must be xlsx, xls',
  'The file format must be txt': 'The file format must be txt',
  'The file size should not exceed 2MB': 'The file size should not exceed 2MB',
  'Wrong file format': 'Wrong file format',
  'FIO': 'Full name',
  'Company name': 'Company name',
  'International payment': 'International payment',
  'Transaction date': 'Transaction date',
  'Back': 'Back',
  'Repeat': 'Repeat',
  'Urgent': 'Urgent',
  'Edit account name': 'Edit account name',
  'Maximum number of characters: 70': 'Maximum number of characters: 70',
  'Exit': 'Exit',
  'Pick': 'Pick',
  'Enter number or letter only': 'Enter number or letter only',
  'Sure to confirm?': 'Are you sure you want to confirm?',
  'Sure to decline?': 'Are you sure you want to decline?',
  'Cancel': 'Cancel',
  'Make a payment': 'Make a payment',
  'Enter': 'Enter',
  'Insufficient funds in the account': 'Insufficient funds in the account',
  'Templates': 'Templates',
  'Internal': 'Internal',
  'Delete': 'Delete',
  'BIC': 'BIC',
  'No Templates': 'No Templates',
  'Statement': 'Statement',
  'Exchange': 'Exchange',
  'Credit amount': 'Credit amount',
  'Debit amount': 'Debit amount',
  'Beneficiary Bank': 'Beneficiary Bank',
  'Print': 'Print',
  'View all': 'View all',
  'otpType': 'Choose a method to receive the verification code',
  'withSMS': 'via SMS',
  'withEmail': 'via Email',
  'Email': 'Email',
  'Recipient country': 'Recipient country',
  'Recipient city': 'Recipient city',
  'Recipient address': 'Recipient address',
  'Recipient bank address': 'Recipient bank address',
  'Recipient bank name': 'Recipient bank name',
  'Recipient country name': 'Recipient country name',
  'Recipient bank swift': 'Recipient bank swift',
  'onlyTwoMonths': 'No more than two months',
  'Oriyon': 'Oriyon',
  'Business': 'Business',
  'Account Balances': 'Account balances',
  'Account Balances in somoni': 'Account balances in somoni',
  'Account Balances in dollars': 'Account balances in dollars',
  'Account Balances in euro': 'Account balances in euro',
  'Account Balances in ruble': 'Account balances in ruble',
  'Account Balances in riyal': 'Account balances in riyal',
  'Account Balances in yuan': 'Account balances in yuan',
  'Select format': 'Select format',
  'Format': 'Format',
  'PrepaymentForProduct': 'Prepayment for product',
  'PaymentForProduct': 'Payment for product',
  'PrepaymentForService': 'Prepayment for service',
  'PaymentForService': 'Payment for service',
  'Others': 'Others',
  'Enter bic code': 'Enter BIC code',
  'Ruble transfer': 'Ruble transfer',
  'EditionalInfo': 'EditionalInfo',
  'Enter KPP': 'Enter KPP',
  'Correspondent account': 'Correspondent account',
  'All currencies': 'All currencies',
  '4 somoni': '4 somoni',
  'Download extract': 'Download extract',
  'Closed': 'Closed',
  'Loan amount': 'Loan amount',
  'Loan end date': 'Loan end date',
  'Loan balance': 'Loan balance',
  'Loan Information': 'Loan Information',
  'Loan type': 'Loan type',
  'Download payment schedule': 'Download payment schedule',
  'Accredits': 'Letter of credit',
  'Overdraft': 'Overdraft',
  'No loans': 'No loans',
  'Next payment date': 'Next payment date',
  'Amount due': 'Repayment amount',
  'Deposit owner': 'Deposit owner',
  'Deposit Information': 'Deposit Information',
  'Month': 'Month',
  'Percent': 'Percent',
  'Loan requests': 'Loan requests',
  'Submit request': 'Submit request',
  'Loan term': 'Loan term',
  'Purpose': 'Purpose',
  'No requests': 'No requests',
  'Request create title': 'Online financing request',
  'Request preview title': 'Request preview before sending',
  'Deal parameters': 'Deal parameters',
  'Applicant data': 'Applicant data',
  'Loan product type': 'Loan product type',
  'Financing amount': 'Financing amount',
  'Desired term in months': 'Desired term (in months)',
  'Financing purpose': 'Financing purpose',
  'Director full name': 'General director full name',
  'Generate preview': 'Generate preview',
  'Back to edit': 'Back (Edit)',
  'Send request to bank': 'Send request to bank',
  'Request submitted': 'Request successfully submitted!',
  'Request submitted desc': 'The bank will review your request and contact you using the details provided.',
  'Back to requests': 'Back to requests',
  'Product type Loan': 'Loan',
  'Additional documents': 'Additional documents',
  'Recommended documents list': 'Recommended documents list',
  'up to': 'up to',
  'Select file': 'Select file',
  'Attached documents': 'Documents attached to the request',
  'No documents attached': 'No additional documents were uploaded (LOI request only)',
  'File is too large': 'File is too large',
  'MB': 'MB',
  'Document bank form': 'Bank form request',
  'Document balance': 'Company balance sheet',
  'Document passports': 'Management passports',
  'Document contracts': 'Contracts',
  'Document feasibility study': 'Feasibility study',
  'No deposits': 'No deposits',
  'Counterparties': 'Counterparties',
  'Add': 'Add',
  'New counterparty': 'New counterparty',
  'Foreigs': 'Foreigs',
  'Residents': 'Residents',
  'Resident': 'Resident',
  'Personal': 'Personal',
  'Public': 'Public',
  'Yes': 'Yes',
  'No': 'No',
  'templateType': 'Template type',
  'downloadTemplates': 'Download templates',
  'today': 'Today',
  'for3days': 'For 3 days',
  'forWeek': 'For a week',
  'forMonth': 'For a month',
  'Select counterparty': 'Select counterparty',
  'Pick counterparty': 'Pick counterparty',
  'Download list': 'Download list',
  'Operation is not permitted': 'Operation is not permitted',
  'Own accounts payment shortname': 'Own accounts',
  'Electric': 'Electricity',
  'Select region': 'Select region',
  'Electricity payment': 'Electricity payment',
  'Personal account number': 'Personal account number',
  'Indication': 'Indication',
  'Select language': 'Select language',
  'Clean': 'Clean',
  'Download selected': 'Download selected',
  'Custom payments': 'Custom payments',
  'Payer': 'Payer',
  'Account owner': 'Owner',
  'TinNotFoundInAsycuda': 'The TIN was not found in the ASYCUDA system.',
  'Disposal': 'Disposal',
  'Disposal payment': 'Disposal payment',
  'Custom payment attention': 'Customs payments are processed exclusively through the "Customs Payments" tab.',
  'Leave a review': 'Leave a review',
  'Username': 'Username',
  'Support service': 'Support service',
  'Write to chat': 'Write to chat',
  'Online support': 'Online support',
  'Frequently asked questions': 'Frequently asked questions',
  'Your feedback helps us': 'Your feedback helps us',
  'Review': 'Review',
  'Suggestion': 'Suggestion',
  'Send': 'Send',
  'Thank you for your feedback': 'Thank you for your feedback',
  'Message': 'Message',
  'Type of request': 'Type of request',
  'Security': 'Security',
  'Quick navigation': 'Quick navigation',
  '2FA On': 'enabled',
  '2FA Off': 'disabled',
  'Phone label': 'Phone',
  'Contact info': 'Contact info',
  'Contact info desc': 'Phone and email for notifications and confirmations',
  'Change contact info': 'Change contact info',
  'Enter phone number': 'Enter phone number',
  'Enter email': 'Enter email',
  'Invalid email': 'Invalid email address',
  'ConfirmContactInfoOtp': 'A confirmation code has been sent to you to confirm the contact info change',
  'Name label': 'Name',
  'Payments nav desc': 'Create and send a payment',
  'Statement nav desc': 'Account statement',
  'Accounts nav desc': 'All bank accounts',
  'Transactions nav label': 'Transaction history',
  'Transactions nav desc': 'All transactions',
  'Templates nav desc': 'Saved templates',
  'Enabled': 'Enabled',
  'Disabled': 'Disabled',
  'Connect Google Auth': 'Connect Google Authenticator',
  'Scan QR code': 'Scan the QR code in the Google Authenticator app',
  'After scan click enable': 'After scanning, click «Enable»',
  'Enable': 'Enable',
  'Disable': 'Disable',
  'Disable 2FA title': 'Disable two-factor authentication',
  'Disable 2FA confirm':
    'Are you sure you want to disable two-factor authentication? This will reduce the security of your account.',
  'swiftAttention': {
    'title': 'Important Information',
    'dearClients': 'Dear Clients',
    'payAttention':
      'In order to prevent errors and any potential consequences arising from them, we kindly ask you to exercise utmost care when entering payment details — ',
    'narrative': 'particularly in the «Payment Purpose» field',
    'file': 'Please also ensure that all supporting documents are attached when submitting your payment',
  },
  'Footer': {
    'address':
      'Republic of Tajikistan, Dushanbe, Rudaki Avenue 95/1 C/A: 20402972413691, TIN: 020003038, BIC: 350101369',
    'emails': 'Email address',
    'tj': 'For calls within Tajikistan',
    'nbt': 'Hotline of the National Bank of Tajikistan',
    'workTime': 'Work time',
    'workDays': 'Working days: Monday to Friday from 08:00 to 17:00',
    'sunday': 'Sunday is a day off',
    'orb': 'OJSC "Oriyonbonk"',
    'license': 'NBT License No. 0000004 dated January 30, 2014',
    'supportNumber': 'Orienbusiness Support Service',
    'dayOf': 'Saturday and Sunday are day off',
  },
  'security': {
    'title': 'Your business security: how to avoid falling for fraudsters',
    'sectionPrefix': 'Section',
    'section1Title': 'Verifying request authenticity',
    'section1Subtitle': 'Your basic security rules for communication.',
    'section2Title': 'Business compliance security',
    'section2Subtitle': 'Recommendations to protect the company from account blocks and legal risks.',
    'labelAction': 'Action',
    'labelConsequence': 'Consequence',
    'labelRule': 'Rule',
    'labelRisk': 'Risk',
    'labelCheck': 'Control point',
    's1i1Title': '"Urgent request from a manager"',
    's1i1Text':
      'If you receive a messenger or email request from your director asking you to urgently transfer money to new bank details — this is a red flag. Fraudsters can imitate communication style and even voice.',
    's1i1Action': 'Always call the manager back on a regular phone number and confirm the order in person.',
    's1i2Title': '"Fake tech support"',
    's1i2Text':
      'Calls from "bank employees" asking you to install AnyDesk, RustDesk or TeamViewer to "set up the system".',
    's1i2Action': 'Hang up immediately. The bank never requires the installation of remote access programs.',
    's1i3Title': 'Number spoofing',
    's1i3Text': "Fraudsters use technology to display the Bank's official number on your mobile phone screen.",
    's1i3Action':
      'If they ask you for SMS codes or passwords — end the call and dial the bank yourself using the number on the official website.',
    's2i1Title': '"Transit" risk (AML/CFT)',
    's2i1Text': 'You receive an "accidental" payment and are asked to return it — but to different details or in cash.',
    's2i1Consequence':
      'You become a link in a money laundering chain, which leads to all company accounts being blocked.',
    's2i1Rule': 'Return funds only based on an official letter and only to the account from which the money was sent.',
    's2i2Title': 'Sanctions traps',
    's2i2Text':
      'The counterparty offers complex payment schemes through a chain of intermediaries or to third-party accounts.',
    's2i2Risk':
      'Violation of international sanctions, which may deprive the bank and your company of access to currency operations.',
    's2i3Title': 'Fictitious services',
    's2i3Text':
      'Payment for marketing, consulting or IT services to companies without staff, office or operational history.',
    's2i3Check':
      'The bank verifies the reality of operations. Working with shell companies is a sign of fund withdrawal.',
    'alertTitle': 'If you suspect fraud:',
    'alertStep1': 'Turn off the internet on your computer (unplug the cable).',
    'alertStep2Prefix': 'Call the Bank at:',
  },
  'interbankAttention': {
    'title': 'Attention!',
    'intro': 'When submitting tax payments, please make sure that:',
    'item1': 'The taxpayer identification numbers (TIN) of the payer and the beneficiary are correct;',
    'item2': 'The payment codes match the purpose of the payment;',
    'item3': 'All required fields are filled in (including the income classification).',
    'footer': 'Errors may lead to the payment being rejected or taxes being credited incorrectly.',
  },
};

export default translations;
